import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export const IndeterminateIcon = (props) => (_jsx("svg", Object.assign({ viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("rect", { width: "10", height: "2", x: "3", y: "7", rx: "1" }) })));
